module.exports = __webpack_public_path__ + "img/emptystate.ca5e1078.png";